import React from "react";
import { Navigate } from "react-router-dom";
import { userHasRolePermission } from "../../../api/ApiUtils";

export default function ProtectedRoute({ children, redirectTo, roles }) {
  const userHasRole = (roles) => {
    let hasPermission = userHasRolePermission(`Admin,${roles}`);
    return hasPermission;
  };

  const isAuthenticated = userHasRole(roles);
  return isAuthenticated ? children : <Navigate to={redirectTo} />;
}
